export default __webpack_public_path__ + "fee9b9cd80fdc912af82bf3788c7eda4.svg";